import React from 'react';

const DataTable = ({ data, columns, onRowClick }) => (
  <div className="relative overflow-x-auto shadow-md sm:rounded-lg">
    <table className="w-full text-sm text-left text-gray-500 dark:text-gray-400">
      <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400 font-semibold">
        <tr>
          {columns.map((col, index) => (
            <th key={index} className="px-6 py-3">{col.header}</th>
          ))}
        </tr>
      </thead>
      <tbody>
        {data.map((item, key) => (
          <tr 
            key={key} 
            className={key % 2 === 0 ? 
              "bg-white border-b dark:bg-gray-900 dark:border-gray-700 cursor-pointer" : 
              "border-b bg-gray-50 dark:bg-gray-800 dark:border-gray-700 cursor-pointer"
            }
            onClick={() => onRowClick(item)}
          >
            {columns.map((col, index) => (
              <td key={index} className="px-6 py-4">{col.render(item)}</td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);

export default DataTable;